export function getInitialState () {
    return {
        initialized: false,
    };
}

const pendoCollaboration = {
    namespaced: true,
    state: getInitialState(),
    mutations: {
        setInitialized (state, { initialized }) {
            state.initialized = initialized;
        },
    },
    actions: {
        init ({ commit }) {
            commit('setInitialized', { initialized: true });
        },
        teardown ({ state }) {
            Object.assign(state, getInitialState());
        },
    },
    getters: {
        hasPendoCollaboration: (_state, _getters, _rootState, rootGetters) => {
            return rootGetters['auth/hasSegmentFlag']('pendoCollaboration');
        },
        hasCollaborationAccess: (state) => {
            return state.initialized;
        },
    },
};

export default pendoCollaboration;
